import apiRoutes from 'router/routes/ApiRoutes';

import FetchHelpers from 'utils/FetchHelpers';

export default {
  async reconciliationDiscrepanciesTask(params = {}) {
    const url = apiRoutes.reconciliationDiscrepanciesTasksPath();
    return FetchHelpers.post(url, params);
  },
};
